import React, { useState, useEffect, useRef, useMemo } from "react";
import Search from "./Search";
import NavLg from "./NavLg";
const DUMMY_DATA = [
	{
		_id: "69087073c80632982d5fd502",
		brand: "Monsini",
		year: 2025,
		versionName: "SP25",
		availability: "Yes",
		category: "Prom 2025",
		style: "40057",
		price: 285,
		colors: ["BLACK"],
		size: "0-24",
		viewInfront: true,
		images: [
			"https://demo.riskydress.com/images/2026/ENCHANTED-E/E40233%20%281%29.png",
			"https://demo.riskydress.com/images/2026/ENCHANTED-B/B40351%20%283%29.png",
			"https://demo.riskydress.com/images/2026/MONSINI/50020%20%281%29.png",
		],
	},
	{
		_id: "6907073c80632982d5fd502",
		brand: "Monsini",
		year: 2025,
		versionName: "SP25",
		availability: "Yes",
		category: "Prom 2025",
		style: "400571",
		price: 285,
		colors: ["BLACK"],
		size: "0-24",
		viewInfront: true,
		images: [
			"https://demo.riskydress.com/images/2026/ENCHANTED-E/E40233%20%281%29.png",
			"https://demo.riskydress.com/images/2026/ENCHANTED-B/B40351%20%283%29.png",
			"https://demo.riskydress.com/images/2026/MONSINI/50020%20%281%29.png",
		],
	},
	{
		_id: "6907073c80632982d5fd502",
		brand: "Monsini",
		year: 2025,
		versionName: "SP25",
		availability: "Yes",
		category: "Enchanted Evening 2025",
		style: "400571",
		price: 285,
		colors: ["BLACK"],
		size: "0-24",
		viewInfront: true,
		images: [
			"https://demo.riskydress.com/images/2026/ENCHANTED-E/E40233%20%281%29.png",
			"https://demo.riskydress.com/images/2026/ENCHANTED-B/B40351%20%283%29.png",
			"https://demo.riskydress.com/images/2026/MONSINI/50020%20%281%29.png",
		],
	},
	{
		_id: "6907073c80632982d5fd502",
		brand: "Monsini",
		year: 2025,
		versionName: "SP25",
		availability: "Yes",
		category: "Enchanted Evening 2025",
		style: "400571",
		price: 285,
		colors: ["BLACK"],
		size: "0-24",
		viewInfront: true,
		images: [
			"https://demo.riskydress.com/images/2026/ENCHANTED-E/E40233%20%281%29.png",
			"https://demo.riskydress.com/images/2026/ENCHANTED-B/B40351%20%283%29.png",
			"https://demo.riskydress.com/images/2026/MONSINI/50020%20%281%29.png",
		],
	},
	{
		_id: "69087073c80632982d5fd503",
		brand: "Monsini",
		year: 2026,
		versionName: "EN26",
		availability: "Yes",
		category: "Enchanted Bridal 2026",
		style: "B40350",
		price: 479,
		colors: ["IVORY"],
		size: "2-28",
		viewInfront: true,
		images: [
			"https://demo.riskydress.com/images/2026/MONSINI/50020%20%281%29.png",
			"https://demo.riskydress.com/images/2026/ENCHANTED-B/B40351%20%283%29.png",
			"https://demo.riskydress.com/images/2026/ENCHANTED-E/E40233%20%281%29.png",
		],
	},
	{
		_id: "69087073c80632982d5fd504",
		brand: "Monsini",
		year: 2026,
		versionName: "EN26",
		availability: "Yes",
		category: "Enchanted Bridal 2026",
		style: "B40351",
		price: 425,
		colors: ["IVORY/NUDE"],
		size: "2-28",
		viewInfront: true,
		images: [
			"https://demo.riskydress.com/images/2026/ENCHANTED-E/E40233%20%281%29.png",
			"https://demo.riskydress.com/images/2026/ENCHANTED-B/B40351%20%283%29.png",
			"https://demo.riskydress.com/images/2026/MONSINI/50020%20%281%29.png",
		],
	},
	{
		_id: "69087073c80632982d5fd505",
		brand: "Monsini",
		year: 2026,
		versionName: "EN26",
		availability: "Yes",
		category: "Enchanted Bridal 2026",
		style: "B40352",
		price: 499,
		colors: ["IVORY"],
		size: "2-28",
		viewInfront: true,
		images: [
			"https://demo.riskydress.com/images/2026/ENCHANTED-B/B40351%20%283%29.png",
			"https://demo.riskydress.com/images/2026/MONSINI/50020%20%281%29.png",
			"https://demo.riskydress.com/images/2026/ENCHANTED-E/E40233%20%281%29.png",
		],
	},
	{
		_id: "69087073c80632982d5fd506",
		brand: "Monsini",
		year: 2026,
		versionName: "EN26",
		availability: "Yes",
		category: "Enchanted Bridal 2026",
		style: "B40353",
		price: 499,
		colors: ["IVORY/SAND", "IVORY/IVORY"],
		size: "2-28",
		viewInfront: true,
		images: [
			"https://demo.riskydress.com/images/2026/ENCHANTED-B/B40351%20%283%29.png",
			"https://demo.riskydress.com/images/2026/ENCHANTED-E/E40233%20%281%29.png",
			"https://demo.riskydress.com/images/2026/MONSINI/50020%20%281%29.png",
		],
	},
	{
		_id: "69087073c80632982d5fd507",
		brand: "Monsini",
		year: 2025,
		versionName: "SP25",
		availability: "No",
		category: "Enchanted Evening 2025",
		style: "E40233",
		price: 350,
		colors: ["NAVY", "BURGUNDY"],
		size: "0-26",
		viewInfront: false,
		images: [
			"https://demo.riskydress.com/images/2026/ENCHANTED-B/B40351%20%283%29.png",
			"https://demo.riskydress.com/images/2026/ENCHANTED-E/E40233%20%281%29.png",
			"https://demo.riskydress.com/images/2026/MONSINI/50020%20%281%29.png",
		],
	},
];

export default function Navbar() {
	const [isScrollingUp, setIsScrollingUp] = useState(true);
	const [lastScrollY, setLastScrollY] = useState(0);
	const [menu, setMenu] = useState(false);
	const [years, setYears] = useState([]);
	const [categories, setCategories] = useState([]);
	const [searchbtn, setSearchBtn] = useState(false);
	const [search, setSearch] = useState("");
	const searchRef = useRef(null);

	// Initialize with DUMMY_DATA
	const [data, setData] = useState(DUMMY_DATA);

	useEffect(() => {
		const fetchProducts = async () => {
			try {
				const response = await fetch(
					`https://admin.monsinidress.com/api/products/brand`,
					{
						method: "POST",
						headers: { "Content-Type": "application/json" },
						body: JSON.stringify({ brand: "Monsini" }),
					}
				);

				if (!response.ok) {
					throw new Error("Failed to fetch products");
				}
				const productsData = await response.json();

				// CORRECTED: Check if products array exists and has length > 0
				if (
					productsData.data?.products &&
					productsData.data.products.length > 0
				) {
					setData(productsData.data.products);
					setYears(productsData.data.years || []);
					setCategories(productsData.data.categories || []);
				} else {
					// If API returns no products, keep the dummy data
					console.log("No products from API, using dummy data");
					setYears([2026, 2025]);
					setCategories([
						"Enchanted Bridal 2026",
						"Prom 2025",
						"Enchanted Evening 2025",
					]);
				}
			} catch (error) {
				console.error("Error fetching products:", error);
				// On error, keep the dummy data that was already set initially
				setYears([2026, 2025]);
				setCategories([
					"Enchanted Bridal 2026",
					"Prom 2025",
					"Enchanted Evening 2025",
				]);
			}
		};

		fetchProducts();
	}, []);

	const filteredData = useMemo(() => {
		if (!data || !Array.isArray(data)) return [];

		if (search?.length > 3) {
			return data.filter(
				(item) =>
					item?.style && item.style.toLowerCase().includes(search.toLowerCase())
			);
		}
		return [];
	}, [search, data]);

	const len = useMemo(() => filteredData.length, [filteredData]);

	useEffect(() => {
		const handleScroll = () => {
			const currentScrollY = window.scrollY;
			setIsScrollingUp(currentScrollY < lastScrollY);
			setLastScrollY(currentScrollY);
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, [lastScrollY]);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				searchRef.current &&
				!searchRef.current.contains(event.target) &&
				event.target !== document.documentElement &&
				event.target !== document.body
			) {
				setSearch("");
				setSearchBtn(false);
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);

	return (
		<div className="relative">
			<Search
				filteredData={filteredData}
				search={search}
				setSearch={setSearch}
				len={len}
				searchbtn={searchbtn}
				searchRef={searchRef}
				setSearchBtn={setSearchBtn}
			/>
			<NavLg
				years={years}
				categories={categories}
				menu={menu}
				setMenu={setMenu}
				setShowSearch={setSearchBtn}
				setSearchBtn={setSearchBtn}
				searchbtn={searchbtn}
				isScrollingUp={isScrollingUp}
			/>
		</div>
	);
}
